import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { LabelText } from "../../components";

function TicketSummary({
  tickets,
  totalAmount,
  totalTickets,
}: {
  tickets: {
    ticketName: string;
    ticketPrice: number;
    ticketQuantity: number;
  }[];
  totalAmount: number;
  totalTickets: number;
}) {
  const defaultLabelTextProps = {
    separator: "",
    color: "surface.400",
    justifyContent: "space-between",
  };
  const defaultLabelProps = {
    fontWeight: "bold",
  };
  return (
    <Box backgroundColor="primary.200" borderRadius="10px" overflow="hidden">
      <Heading
        size="md"
        background="primary.500"
        color="white"
        py="1rem"
        px="1.5rem"
      >
        Total Tickets:{" "}
        <Text
          as="span"
          background="info.500"
          rounded="full"
          p="0.25rem"
          px="0.75rem"
          borderRadius="5px"
        >
          {totalTickets}
        </Text>
      </Heading>

      <Stack py="1rem" px="1.5rem" gap="0.25rem">
        {tickets.map((ticket, index) => (
          <LabelText
            key={`ticket__${index}`}
            labelProps={defaultLabelProps}
            label={`${ticket.ticketQuantity} ${ticket.ticketName} X Rs. ${ticket.ticketPrice}`}
            text={`Rs. ${(
              ticket.ticketQuantity * ticket.ticketPrice
            ).toFixed()}`}
            {...defaultLabelTextProps}
          />
        ))}
        <Box
          sx={{
            borderTop: "2px dashed ",
            borderColor: "surface.500",
            boxSizing: "border-box",
          }}
        />
        <LabelText
          labelProps={defaultLabelProps}
          label="Total Amount"
          text={`Rs. ${totalAmount.toFixed()}`}
          color="surface.700"
          justifyContent="space-between"
        />
      </Stack>
    </Box>
  );
}

export default TicketSummary;
